import {
  ExpositionIcon,
  FloorIcon,
  OutsideIcon,
  ParkingIcon,
  PriceIcon,
  RoomsIcon,
  SurfaceIcon,
} from "./propertyInfoIcons";

/**
 * @param {{
 *   price?: string;
 *   priceFormatted?: string;
 *   roomNumbers?: string;
 *   surface?: string;
 *   exposition?: string;
 *   outside?: string;
 *   floor?: string;
 *   parking?: string;
 * }} data
 */
export function getPropertyInfoItems({
  price,
  priceFormatted,
  roomNumbers,
  surface,
  exposition,
  outside,
  floor,
  parking,
}) {
  return [
    {
      key: "price",
      label: "Prix",
      value: price ? `${priceFormatted} €` : "",
      icon: PriceIcon,
    },
    {
      key: "rooms",
      label: "Pièces",
      value: roomNumbers,
      icon: RoomsIcon,
    },
    {
      key: "surface",
      label: "Surface",
      value: surface ? `${surface} m²` : "",
      icon: SurfaceIcon,
    },
    {
      key: "exposition",
      label: "Exposition",
      value: exposition,
      icon: ExpositionIcon,
    },
    {
      key: "outside",
      label: "Extérieur",
      value: outside,
      icon: OutsideIcon,
    },
    {
      key: "floor",
      label: "Étage",
      value: floor,
      icon: FloorIcon,
      iconOffset: false,
    },
    {
      key: "parking",
      label: "Stationnement",
      value: parking,
      icon: ParkingIcon,
    },
  ].filter((item) => Boolean(item.value));
}
